game.services.api = {};

let tempApiUrl = window.location.host;
if (tempApiUrl.indexOf('antwar.io') !== -1) {
    tempApiUrl = 'api.' + tempApiUrl;
}
tempApiUrl = window.location.protocol + '//' + tempApiUrl;
const API_URL = tempApiUrl;

function loadScript(url, callback){
    let scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = callback;
    scriptTag.onreadystatechange = callback;

    document.head.appendChild(scriptTag);
}